import React from 'react';
import ChartGraph from './ChartGraph';
import TableGraph from './TableGraph';
import styled from 'styled-components';
import zoomin from '../../assets/icons/zoom-in.svg';
import close from '../../assets/icons/close.svg';
import heartOutline from '../../assets/icons/heart-o.svg';
import heart from '../../assets/icons/heart.svg';
import FlatButton from '../common/FlatButton';
import SettingsPreview from '../settings/SettingsPreview';

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column-reverse;
  overflow: ${({overflow}) => overflow};
  svg * {
    font-size: 13px;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
`;

const PaddingRow = styled.div`
  padding: ${({theme}) => theme.spacingVertical()} ${({theme}) => theme.spacingHorizontal()};
`;

const Settings = styled(PaddingRow)`
  flex: 1;
`;
const FavoriteDescription = styled(PaddingRow)`
  flex: 1;
  margin-left: -15px;
  font-size: 20px;
  font-weight: bold;
`;

const FullHeightRow = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

const Icon = styled.img`
  height: ${({theme}) => theme.spacingVertical(3)};
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: ${({hasSettings}) => (hasSettings ? 'column' : 'row-reverse')};
`;

const IconButton = styled(FlatButton)`
  font-size: 0;
`;

const Graphic = props => {
  switch (props.data.__typename) {
    case 'ChartReport':
      return <ChartGraph {...props} />;
    case 'TableReport':
      return <TableGraph {...props} />;
    default:
      return null;
  }
};

const hasSettings = props => props.showSettings && props.data.settings;

const hasFavoriteDescription = props => props.showSettings && props.data.settings && props.data.settings.favoriteDesc;

const Graph = props => (
  <Wrapper {...props} overflow={props.data.__typename === 'TableReport' ? 'auto' : null}>
    {props.data.description ? <PaddingRow dangerouslySetInnerHTML={{__html: props.data.description}} /> : null}
    <FullHeightRow>
      <Graphic {...props} />
    </FullHeightRow>
    <Header>
      <ButtonWrapper hasSettings={!props.details && hasSettings(props)}>
        {props.showDetailButton && (
          <IconButton onClick={props.setActive}>
            <Icon src={props.details ? close : zoomin} />
          </IconButton>
        )}
        <IconButton onClick={props.onFavoriteClick}>
          <Icon src={props.isFavorite ? heart : heartOutline} />
        </IconButton>
      </ButtonWrapper>
      <Settings>
        {hasFavoriteDescription(props) && <FavoriteDescription>{props.data.settings.favoriteDesc}</FavoriteDescription>}
        {hasSettings(props) && <SettingsPreview settings={props.data.settings} />}
      </Settings>
    </Header>
  </Wrapper>
);

export default Graph;
